<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Edit Spec Lot Matches</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    (click)="activeModal.dismiss()"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog" *nfLoader="isLoading">
  <div class="body-header">
    <h5>Available Lot Entries</h5>
    <h5>Total Exit Units: {{ context.exitUnits }}</h5>
    <h5>Inventory Method: {{ context.lotInventoryMethod }}</h5>
  </div>

  <nf-table-layout
    [hideTitle]="true"
    [gridOptions]="gridOptions"
    [autoResizeGrid]="false"
    [data]="openLotRows"
    hideSearch
    hideClearAll
  >
  </nf-table-layout>
</div>
<div class="modal-footer" hsDraggable="modal-dialog">
  <div>
    <button nf-button="cancel" (click)="activeModal.dismiss()"></button>
    <button
      nf-button="save"
      (click)="onSubmit()"
      [disabled]="!isDataValid || isLoading"
    ></button>
  </div>
</div>
